<template>
  <validated-form
    name="sendResetPasswordEmailForm"
    @valid-submit="resetPasswordFormSubmitHandler"
  >
    <div class="cf-flex cf-flex--column cf-flex--gap-16 cf-padding-y-16">
      <Teleport
        defer
        to="#portal-modal-header-target"
      >
        Forgot your password?
      </Teleport>

      <p class="cf-subtitle cf-subtitle--2">
        Enter your email address and we'll send you a link to reset your password.
      </p>

      <cf-text-input
        v-model="email"
        type="email"
        label="Email"
        name="emailResetPassword"
        :validations="{
          required: true
        }"
      />

      <button
        :class="['cf-button cf-button--primary cf-button--lg', { 'cf-button--loading': isSendingNewPassword }]"
        type="submit"
      >
        Send Link
      </button>

      <button
        class="cf-button cf-button--secondary cf-button--lg"
        type="submit"
        @click="cancelClickHandler"
      >
        Cancel
      </button>
    </div>
  </validated-form>
</template>


<script>
  import errorHandlers from '@/services/error-handlers';
  import http from '@/services/http';

  import CfTextInput from '@/view/components/shared/cf-text-input/index.vue';


  export default {
    name: 'ForgotPassword',

    components: {
      CfTextInput
    },

    props: {
      title: {
        type: String,
        default: ''
      }
    },

    data() {
      return {
        email: null,
        isSendingNewPassword: false
      };
    },

    methods: {
      cancelClickHandler() {
        this.$closeModal('reset-password-modal');

        this.$openModal('signIn');
      },

      async resetPasswordFormSubmitHandler() {
        try {
          this.isSendingNewPassword = true;

          const httpBody = { emailAddress: this.email };

          await http.post('/cardfree-api/v1/account/password/reset', httpBody);

          // this.$triggerGoogleTrackingEvent('ChangePassword', 'Account');

          this.$triggerNewRelicEvent('ChangePassword', 'Information', 'Changed Password');

          const modalBody = {
            title: 'Success!',
            description: 'If we find your email, you will receive an email in the next few minutes to reset your password.'
          };

          this.$closeModal('reset-password-modal');

          this.$openModal('notice-modal', modalBody);
        }

        catch (error) {
          errorHandlers.generic(error);
        }

        finally {
          this.isSendingNewPassword = false;
        }
      }
    }
  };
</script>
